// extracted by mini-css-extract-plugin
export default {"input-div":"UserInput_input-div__i0ky6"};